/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestigationLockResponse
 */
export interface InvestigationLockResponse {
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationLockResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLockResponse
     */
    lockId?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLockResponse
     */
    personGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLockResponse
     */
    accountGoldenId?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLockResponse
     */
    incidentId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvestigationLockResponse
     */
    released?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvestigationLockResponse
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the InvestigationLockResponse interface.
 */
export function instanceOfInvestigationLockResponse(value: object): value is InvestigationLockResponse {
    return true;
}

export function InvestigationLockResponseFromJSON(json: any): InvestigationLockResponse {
    return InvestigationLockResponseFromJSONTyped(json, false);
}

export function InvestigationLockResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestigationLockResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'lockId': json['lockId'] == null ? undefined : json['lockId'],
        'personGoldenId': json['personGoldenId'] == null ? undefined : json['personGoldenId'],
        'accountGoldenId': json['accountGoldenId'] == null ? undefined : json['accountGoldenId'],
        'incidentId': json['incidentId'] == null ? undefined : json['incidentId'],
        'released': json['released'] == null ? undefined : json['released'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function InvestigationLockResponseToJSON(json: any): InvestigationLockResponse {
    return InvestigationLockResponseToJSONTyped(json, false);
}

export function InvestigationLockResponseToJSONTyped(value?: InvestigationLockResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'lockId': value['lockId'],
        'personGoldenId': value['personGoldenId'],
        'accountGoldenId': value['accountGoldenId'],
        'incidentId': value['incidentId'],
        'released': value['released'],
        'errorMessage': value['errorMessage'],
    };
}

